<template>
  <!-- title="导入商品中心资料（以下是未导入到小店的商品（即不可分销商品），若添加到小店展示，将改为可分销状态）" -->
  <el-dialog
    :visible.sync="dialogVisible"
    width="1200px"
    @close="handleClose"
  >
    <span slot="title">
      <span class="center-title">导入商品中心资料</span>
      <span class="tips"></span>
    </span>
    <div class="import-center">
      <Search ref="search" @search="search" />
      <div class="btns">
        <el-button type="primary" @click="fetch_importBaseItems">
          批量添加到海报
        </el-button>
        <span class="text-999">
          （添加的商品也将同步到小店商品列表）
        </span>
      </div>
      <Table ref="table" :list="list" />
      <el-pagination
        :style="{ padding: '8px 16px', textAlign: 'right' }"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span> -->
    <!-- 小店导入结果 -->
    <ShopPlatFromResult
      :outerIds="outerIds"
      ref="shopPlatFromResult"
      :resultData="shopResultData"
    />
  </el-dialog>
</template>

<script>
import Search from "@/components/prod/center/dialogs/importCenterDialog/search";
import Table from "@/components/prod/center/dialogs/importCenterDialog/table";
import ShopPlatFromResult from "@/components/prod/center/dialogs/shopPlatFormResult";
import { getGoodsList } from "@/servers/prod/center";
import { getImportBaseItems } from "@servers/commodity/index";

export default {
  data() {
    return {
      dialogVisible: false,
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
      list: [],
      shopResultData: {
        totalNum: 0,
        successNum: 0,
        failedList: [],
      },
      outerIds: [],
    };
  },
  components: {
    Search,
    Table,
    ShopPlatFromResult,
  },
  methods: {
    handleClose() {
      this.$emit("callback");
    },
    // 批量导入
    async fetch_importBaseItems() {
      const selectedRows = this.$refs.table.method_getSelectedArr();
      const searchParams = this.$refs.search.method_getSearchForm();
      if (!selectedRows) return this.$message.warning("请先选择商品");
      if (searchParams.importStatus == 1)
        return this.$message.warning("所选商品已在小店中，不能重复导入");
      this.outerIds = selectedRows.map(({ outerId }) => outerId);
      const res = await getImportBaseItems({
        baseItemList: selectedRows.map(item => {
          return {
            id: item.id,
            companyId: item.companyId,
          };
        }),
      });
      if (!res) return;
      if (res.finished) {
        this.shopResultData = { ...res.result };
        this.$refs.shopPlatFromResult.method_open();
      }
    },
    method_open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.search();
      });
    },
    // 搜索触发
    search() {
      this.pagination.pageNo = 1;
      this.fetch_list();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_list();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_list();
    },
    async fetch_list() {
      const { pageNo, pageSize } = this.pagination;
      const searchParams = this.$refs.search.method_getSearchForm();
      const _params = {
        pageNo,
        pageSize,
        ...searchParams,
      };
      const res = await getGoodsList(_params);
      if (!res) return;
      const { records, total } = res;
      this.list = records;
      this.pagination.total = total;
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.center-title {
  line-height: 24px;
  font-size: 14px;
  color: #fff;
}
.tips {
  font-size: 12px;
  display: inline-block;
  margin-left: 20px;
  color: #fff;
  opacity: 0.6;
}
</style>
